import { Tabs } from 'antd';
import './index.less';
import { useState } from 'react'
import ShipmentPage from "./components/ShipmentPage";
const { TabPane } = Tabs;

const OrderShipments = (props)=>{
  const defaultActiveKey = '1';
  const [activeKey, setActiveKey] = useState(defaultActiveKey)
  const onChangeTab = (activeKey) =>{
    setActiveKey(activeKey)
  }
  return (
    <div className="order-shipments">
      <Tabs defaultActiveKey={defaultActiveKey} onChange={onChangeTab}>
        <TabPane tab="待发货" key="1">
          <ShipmentPage type='1' activeKey={activeKey} rootProps={props} />
        </TabPane>
        <TabPane tab="已发货" key="2">
          <ShipmentPage type='2' activeKey={activeKey} rootProps={props} />
        </TabPane>
      </Tabs>
    </div>
  )
}
export default OrderShipments
